import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import {
  IconButton,
  InputAdornment,
  Modal,
  TextField,
  Typography,
} from '@material-ui/core';
import { Search } from '@material-ui/icons';
import selectTableHOC from 'react-table/lib/hoc/selectTable';
import ActionButton from '../../../components/ActionButton';
import ReactTable from 'react-table';
import {
  getConsulentiFiltered,
  getTotaleConsulenti,
} from '../../../utils/api/consulenti_api';
import { reportApiError } from '../../../utils/reportApiError';

const styles = (theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textAlign: 'center',
    gap: theme.spacing(4),
    backgroundColor: 'white',
    color: 'black',
    padding: theme.spacing(3),
    borderRadius: '6px',
    boxShadow: theme.shadows[6],
    overflowY: 'auto',
    width: '90%',
    maxWidth: '960px',
    maxHeight: '90vh',
  },
});

const SelectTable = selectTableHOC(ReactTable);

class ModalSelezioneConsulente extends Component {
  constructor(props) {
    super(props);
    this.state = {
      consulenti: [],
      colonneConsulenti: [],
      selectedConsulente: -1,

      emailFilter: '',
      nameFilter: '',
      cognomeFilter: '',

      loadedPage: 0,
      totalPages: 1,
      loading: false,
    };
  }

  componentDidMount() {
    if (localStorage.getItem('superconsulente') === 'true') {
      if (this.props.gruppoId != null) {
        this.onFetchData({ page: 0, pageSize: 10 });
      }
    }
  }

  getConsulenteColumn = () => {
    return [
      {
        Header: 'Id',
        id: 'IdConsulente',
        accessor: (data) => data.id,
        width: 155,
        filterable: false,
      },
      {
        Header: 'Email',
        id: 'EmailConsulente',
        accessor: (data) => data.email,
        minWidth: 210,
        Filter: (cellInfo) => (
          <TextField
            value={this.state.emailFilter}
            onChange={(event) => {
              this.setState({
                emailFilter: event.target.value,
              });
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => {
                      this.setState({ loadedPage: 0 }, () =>
                        this.onFetchData({ page: 0, pageSize: 10 }),
                      );
                    }}
                  >
                    <Search />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        ),
      },
      {
        Header: 'Nome',
        id: 'NomeConsulente',
        accessor: (data) => data.nome,
        width: 180,
        Filter: (cellInfo) => (
          <TextField
            value={this.state.nameFilter}
            onChange={(event) => {
              this.setState({
                nameFilter: event.target.value,
              });
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => {
                      this.setState({ loadedPage: 0 }, () =>
                        this.onFetchData({ page: 0, pageSize: 10 }),
                      );
                    }}
                  >
                    <Search />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        ),
      },
      {
        Header: 'Cognome',
        id: 'CognomeConsulente',
        accessor: (data) => data.cognome,
        width: 180,
        Filter: (cellInfo) => (
          <TextField
            value={this.state.cognomeFilter}
            onChange={(event) => {
              this.setState({
                cognomeFilter: event.target.value,
              });
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => {
                      this.setState({ loadedPage: 0 }, () =>
                        this.onFetchData({ page: 0, pageSize: 10 }),
                      );
                    }}
                  >
                    <Search />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        ),
      },
    ];
  };

  toggleSelection = (key, shift, row) => {
    const selectedId = parseInt(key.split('select-')[1], 10);
    this.setState({
      selectedConsulente: selectedId,
    });
  };

  isSelected = (key) => {
    return parseInt(key, 10) === this.state.selectedConsulente;
  };

  onFetchData = (state) => {
    this.setState({ loading: true });

    const { emailFilter, nameFilter, cognomeFilter } = this.state;

    getTotaleConsulenti(
      this.props.gruppoId,
      null,
      emailFilter,
      nameFilter,
      cognomeFilter,
    )
      .then((count) => {
        const totalPages = Math.ceil(count / state.pageSize);
        this.setState({ totalPages });
      })
      .catch((error) => {
        this.setState({ loading: false });
        reportApiError(error);
      });

    return getConsulentiFiltered(
      null,
      this.props.gruppoId,
      state.page,
      state.pageSize,
      'id',
      emailFilter,
      nameFilter,
      cognomeFilter,
    )
      .then((response) => {
        this.setState({
          consulenti: response,
          colonneConsulenti: this.getConsulenteColumn(),
          loading: false,
          loadedPage: state.page,
        });
      })
      .catch((error) => {
        reportApiError(error);
        this.setState({
          loading: false,
        });
      });
  };

  render() {
    const { classes } = this.props;

    return (
      <Modal
        open={this.props.isModalOpen}
        onClose={this.props.closeModal}
        className={classes.modal}
      >
        <div className={classes.modalContainer}>
          <Typography variant="h5">
            Selezionare il consulente da associare al nuovo manuale
          </Typography>
          <SelectTable
            selectType="radio"
            toggleSelection={this.toggleSelection}
            isSelected={this.isSelected}
            keyField={'id'}
            filterable={true}
            resizable={true}
            showPageSizeOptions={false}
            showPageJump={false}
            showPaginationBottom={true}
            style={{ width: '85%' }}
            defaultPageSize={10}
            loading={this.state.loading}
            loadingText="Caricamento..."
            page={this.state.loadedPage}
            pages={this.state.totalPages}
            onPageChange={(pageIndex) => {
              this.setState(
                {
                  loadedPage: pageIndex,
                },
                () => {
                  this.onFetchData({ page: pageIndex, pageSize: 10 });
                },
              );
            }}
            manual
            onFetchData={(state) => this.onFetchData(state)}
            columns={this.state.colonneConsulenti}
            data={this.state.consulenti}
            previousText="Precedente"
            nextText="Successivo"
            noDataText="Nessun consulente trovato"
            pageText="Pagina"
            ofText="di"
            rowsText="righe"
            pageJumpText="Vai a pagina"
            rowsSelectorText="righe per pagina"
          />
          <div>
            <ActionButton
              secondaryButton
              onClick={this.props.closeModal}
              label="Annulla"
              disabled={false}
              grayVersion={false}
            />
            <ActionButton
              onClick={() => {
                this.props.openEserciziModal(this.state.selectedConsulente);
              }}
              label="Prosegui"
              disabled={false}
              grayVersion={false}
            />
          </div>
        </div>
      </Modal>
    );
  }
}

ModalSelezioneConsulente.propTypes = {
  classes: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
  gruppoId: PropTypes.number.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  openEserciziModal: PropTypes.func.isRequired,
};

export default withStyles(styles)(ModalSelezioneConsulente);
